var path = '/app/components/ui/memory-game/memory-game.html';
var html = "<div class=\"stage-box yellow-box\"> <div class=\"box-title yellow-box\" ng-bind-html=$ctrl.title> </div> <div class=cards> <div class=card-face ng-class=c.class ng-repeat=\"c in $ctrl.cards track by $index\"> <img width=100px class=front height=149px ng-click=$ctrl.openCard($index) ng-src={{$ctrl.cover}} /> <img width=100px class=back height=149px ng-click=$ctrl.openCard($index) ng-src={{c.src}} /> </div> </div> </div> ";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;


//////////////////
// WEBPACK FOOTER
// ./src/app/components/ui/memory-game/memory-game.html
// module id = 183
// module chunks = 0